import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_application_api } from '@axo/shared/data-access/api';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  loanApplicationDocumentsKeys,
  parseLoanApplicationDocumentsKeys,
} from '../cache-keys/loanApplicationDocumentsKeys';
import { queryFunction } from '../query-function';
import { LoanApplicationDocument } from '@axo/shared/data-access/types';

export function useLoanApplicationDocuments(
  applicationID: string | undefined | null
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = loanApplicationDocumentsKeys.root({
    applicationID: applicationID ?? '',
  });

  return useQuery(
    cacheKey,
    queryFunction(
      loan_application_api.getLoanApplicationDocuments(api),
      ({ queryKey }) =>
        parseLoanApplicationDocumentsKeys(queryKey).applicationID ?? ''
    ),
    { enabled: !!state.user.token && !!applicationID }
  );
}

export function usePatchLoanApplicationDocument() {
  const api = useAPI();
  const client = useQueryClient();

  return useMutation(
    ({
      applicationID,
      documentID,
      data,
    }: {
      applicationID: string;
      documentID: string;
      data: Partial<LoanApplicationDocument>;
    }) =>
      loan_application_api.patchLoanApplicationDocument(api)({
        applicationID,
        documentID,
        data,
      }),
    {
      onSuccess: (_, params) => {
        return client.invalidateQueries(
          loanApplicationDocumentsKeys.root({
            applicationID: params.applicationID,
          })
        );
      },
    }
  );
}
